import React from 'react';


function Journal(){
    return(
        <div>

        </div>
    );
}
export default Journal;